import { render, staticRenderFns } from "./Panther.vue?vue&type=template&id=37c59436&scoped=true"
import script from "./Panther.vue?vue&type=script&lang=js"
export * from "./Panther.vue?vue&type=script&lang=js"
import style0 from "./Panther.vue?vue&type=style&index=0&id=37c59436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c59436",
  null
  
)

export default component.exports